export default __webpack_public_path__ + "static/media/Q9_2_resized.bd08b441.jpg";